import { h, Component } from 'preact';
import style from './style.less';
import SimpleVerticalCard from '../../../cards/simple-vertical-card';
import SimpleGridCluster from '../../simple-grid-cluster';
import CardHeader from '../../../pieces/card-header';
import { fetchArticleList } from '../../../../lib/data';
import { fetchFromDailyMotionPlaylist } from '../../../../lib/dailymotion';

import { TrackingProvider, DIMENSION } from '@cube/track';

/**
 * The main cluster used to display a category of information
 * Layout:
 * - one full width simple vertical
 * - 2x2 simple vertical cards
 * @param {Object} assets contents for the cards
*/
export default class CategoryCluster extends Component {

	state = {
		topAsset: null,
		middleAssets: [],
		bottomAssets: [],
		hasResults: false
	};

	getAssets = (props) => {
		let vamCount = 0, dmCount = 0;

		if (props.dmPlaylist && props.dmLocation) {
			if (props.dmLocation.zone1) dmCount++; else vamCount++;
			if (props.dmLocation.zone2) dmCount+=2; else vamCount+=2;
			if (props.dmLocation.zone3) dmCount+=2; else vamCount+=2;

			fetchFromDailyMotionPlaylist({ limit: dmCount, ...props }).then( res => {
				if (res.articles && res.articles.length > 0) {
					let newState = { hasResults: true };

					if (props.dmLocation.zone1) {
						newState.topAsset = res.articles[0];
					}
					if (props.dmLocation.zone2) {
						let start = (props.dmLocation.zone1 ? 1 : 0);
						newState.middleAssets = res.articles.slice(start, start+2);
					}
					if (props.dmLocation.zone3) {
						let start = (props.dmLocation.zone1 ? 1 : 0) + (props.dmLocation.zone2 ? 2 : 0);
						newState.bottomAssets = res.articles.slice(start, start+2);
					}

					this.setState(newState);
				}
			});
		}
		else {
			// All filled by VAM
			vamCount = 5;
			props.dmLocation = { zone1: false, zone2: false, zone3: false };
		}

		if (vamCount > 0) {
			return fetchArticleList({
				count: vamCount,
				imageSizes: 'w=640,h=360',
				...props }
			)
				.then( res => {
					if (res.articles && res.articles.length > 0) {
						let newState = { hasResults: true };

						if (!props.dmLocation.zone1) {
							newState.topAsset = res.articles[0];
						}
						if (!props.dmLocation.zone2) {
							let start = (!props.dmLocation.zone1 ? 1 : 0);
							newState.middleAssets = res.articles.slice(start, start+2);
						}
						if (!props.dmLocation.zone3) {
							let start = (!props.dmLocation.zone1 ? 1 : 0) + (!props.dmLocation.zone2 ? 2 : 0);
							newState.bottomAssets = res.articles.slice(start, start+2);
						}

						this.setState(newState);
					}
				});
		}
	};

	componentWillMount() {
		this.getAssets(this.props);
	}

	render(
		{ theme, title, link, qeId, ...props },
		{ topAsset, middleAssets, bottomAssets, hasResults }
	) {
		if (!hasResults) return null;

		return (
			<TrackingProvider {...{ [DIMENSION.componentpath]: (title ? title.replace(/\s/g, '') + 'Cluster' : 'CategoryCluster'), [DIMENSION.title]: title }}>
				<div class={style.categoryCluster} qid={qeId}>
					<CardHeader title={title} link={link} qeId={qeId} theme={theme} />
					<div class={style.cards}>
						{ topAsset &&
							<TrackingProvider {...{ [DIMENSION.componentpath]: 'Top', [DIMENSION.clickindex]: 1 }}>
								<SimpleVerticalCard
									theme={theme}
									asset={topAsset}
									imageRole="w=640,h=360"
									cardClass={style.svCard}
									qeId={qeId + '-top-0'}
									{...props}
								/>
							</TrackingProvider>
						}
						{ middleAssets.length === 2 &&
							<TrackingProvider {...{ [DIMENSION.componentpath]: 'Middle' }}>
								<SimpleGridCluster
									theme={theme}
									assets={middleAssets}
									imageRole="w=640,h=360"
									rowCount={1}
									columnCount={2}
									titleLines={4}
									clusterClass={style.sgCluster}
									qeId={qeId + '-middle'}
									{...props}
								/>
							</TrackingProvider>
						}
						{ bottomAssets.length === 2 &&
							<TrackingProvider {...{ [DIMENSION.componentpath]: 'Bottom' }}>
								<SimpleGridCluster
									theme={theme}
									assets={bottomAssets}
									imageRole="w=640,h=360"
									rowCount={1}
									columnCount={2}
									titleLines={4}
									clusterClass={style.sgCluster}
									qeId={qeId + '-bottom'}
									{...props}
								/>
							</TrackingProvider>
						}
					</div>
				</div>
			</TrackingProvider>
		);
	}
}
